import type { JSX } from "react";
import { cn } from "./cn";

export interface PriorityBadgeProps {
  readonly priority: string;
}

const priorityStyles: Readonly<Record<string, string>> = {
  high: "bg-red text-white",
  medium: "bg-amber text-on-bright",
  low: "bg-green text-on-bright",
};

/**
 * Small badge showing task priority level.
 */
export function PriorityBadge({ priority }: PriorityBadgeProps): JSX.Element {
  const lower = priority.toLowerCase();
  return (
    <span className={cn("px-1.5 py-0.5 rounded-full text-[10px]", priorityStyles[lower] ?? "bg-surface-hover text-content")}>
      {priority}
    </span>
  );
}
